import { e as employeeStatus } from "../../../../../chunks/options.js";
const prerender = false;
const load = async ({ locals, fetch, url }) => {
  const query = new URLSearchParams(url.search);
  if (!url.searchParams.has("page")) {
    query.set("page", "1");
  }
  if (!url.searchParams.has("pageSize")) {
    query.set("pageSize", "12");
  }
  if (!url.searchParams.has("search")) {
    query.set("search", "");
  }
  let filter = {};
  url.searchParams.forEach((value, key) => {
    if (key.startsWith("filter[")) {
      filter[key] = value;
    }
  });
  try {
    const response = await fetch(`$api/employees?${query.toString()}`, {
      headers: locals.fetchAuthHeaders
    });
    const paginated_data = await response.json();
    return {
      paginated_data,
      page: Number(query.get("page") || 1),
      pageSize: Number(query.get("pageSize") || 12),
      search: query.get("search") || "",
      sort: query.get("sort") || "lastName",
      order: query.get("order") || "asc",
      ...filter,
      employmentStatus: url.searchParams.get("employmentStatus") || "active",
      page_title: "Employees - Status: " + (employeeStatus[query.get("filter[employmentStatus]")] || "Alle")
    };
  } catch (e) {
    console.log(e);
    console.log("Error fetching employees data.");
  }
  return {
    paginated_data: {
      data: [],
      page: 1,
      pageSize: 10,
      total: 0
    }
  };
};
export {
  load,
  prerender
};
//# sourceMappingURL=_page.server.ts.js.map
